import {useContext, useMemo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {flexCenter} from '~/shared/theme/FlexLayout';
import {BillingLineType} from '~/shared/consts/checkoutConsts';
import PieButton from '~/shared/theme/pie/PieButton';
import {bodyBold, smallBold} from '~/shared/theme/typography';
import {media} from '~/shared/theme/media';

import ShoppingCart from './ShoppingCart';

const PaymentContainer = styled.div`
  ${flexCenter}
  padding: 16px;
`;

const PaymentActionButton = styled(PieButton).attrs({
  variant: 'primaryLarge',
})`
  ${smallBold}
  width: 100%;
  ${media.minLargeTablet`
    ${bodyBold}
  `}
`;

type PaymentsButtonProps = {
  onPayment: () => void;
  disabled: boolean;
};

const ProceedToPaymentButton = ({onPayment, disabled}: PaymentsButtonProps) => {
  const {t} = getLocalizationService();
  const {isDirtyShoppingCart, currentRestaurant, billingLines, isMenuLoading} = useContext(ShoppingCart.Context);

  const totalToChargePrice = useMemo(
    () => billingLines?.find(({type}: {type: BillingLineType}) => type === 'TotalToCharge')?.amount,
    [billingLines],
  );

  const isPaymentDisabled = disabled || isDirtyShoppingCart || !currentRestaurant || isMenuLoading;

  return (
    <PaymentContainer>
      <PaymentActionButton
        onClick={onPayment}
        disabled={isPaymentDisabled}
        aria-label={t('shopping_cart_continue_to_payment_aria_label', {totalPrice: totalToChargePrice || 0})}
        testId="proceedToCheckoutBtn"
        isLoading={isDirtyShoppingCart}
      >
        <div>{t('continue_to_payment')}</div>
      </PaymentActionButton>
    </PaymentContainer>
  );
};

export default ProceedToPaymentButton;
